<template>
  <div class="top-bar-Section">
    <v-menu v-model="menuOpen" location="bottom end">

      <!-- ACTIVADOR -->
      <template v-slot:activator="{ props }">
        <span  v-bind="props" icon
         style="margin-right: 20px; cursor: pointer;">
          <v-icon>mdi-account-circle</v-icon>
          {{ user?.name }}
        </span>
      </template>

      <!-- CONTENIDO -->
      <v-list>

        <v-list-item prepend-icon="mdi-help-circle-outline" title="Ayuda" to="/help" @click="closeMenu" />

        <v-list-item prepend-icon="mdi-book-open-blank-variant-outline" title="Términos de uso"
          href="https://commercia.app/terminos_uso_app" target="_blank" @click="closeMenu" />

        <v-list-item prepend-icon="mdi-shield-check-outline" title="Política de privacidad"
          href="https://commercia.app/privacidad_app" target="_blank" @click="closeMenu" />

        <v-divider />

        <v-list-item prepend-icon="mdi-login-variant" title="Cerrar sesión" @click="handleLogout" />

      </v-list>
    </v-menu>
  </div>
</template>
<script>
export default {
  name: 'CommerciaVueTopBar',
  data () {
    return {
      menuOpen: false
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    }
  },
  methods: {
    closeMenu () {
      this.menuOpen = false
    },
    logout () {
      this.$store.dispatch('logout')
    },
    handleLogout () {
      this.closeMenu()
      this.logout()
    }
  }

}
</script>
<style scoped>
.top-bar-Section {
  width: 100%;
  background-color: #FFFFFF;
  height: 50px;
  box-shadow: 0px -2px 5px rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;

}

.list-actions-user {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0;
}
</style>
